export default __webpack_public_path__ + "static/media/svg-5.57cf89d7.svg";